import "./NotificationFooter.css";

const NotificationFooter = () => {
  return <span id="notificationIcon">82</span>;
};

export default NotificationFooter;
